module.exports = "<h3>Matriz de Conflicto</h3>\n<mat-nav-list>\n  <div *ngFor=\"let matriz of matrices | async\">\n    <a mat-list-item [routerLink]=\"'matriz/'+matriz.id\"> {{ matriz.nombre }}</a>\n  </div>\n</mat-nav-list>\n<button mat-raised-button (click)=\"newMatrix()\" color=\"primary\">Nueva Matriz</button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/list/list.component.html
// module id = ./src/app/list/list.component.html
// module chunks = main